<template>
  <div class="grid-map-filter-card-container">
    <vs-collapse>
      <vs-collapse-item open>
        <div class="aisea-text-16-400-white" slot="header">
          {{ filterTitle }}
        </div>
        <vs-row vs-type="flex" class="aisea-mt-2 filter-card">
          <vs-col
            vs-order="1"
            vs-type="flex"
            vs-justify="start"
            vs-align="center"
            vs-w="6"
          >
            <span class="aisea-text-16-300-white">全て</span>
          </vs-col>
          <vs-col
            vs-order="2"
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="center"
            vs-w="6"
          >
            <vs-switch
              :color="AISEA_COLOR.BLUE"
              :value="isAllSwitch"
              :vs-value="true"
              @input="handleClickAll"
            />
          </vs-col>
        </vs-row>

        <vs-divider class="aisea-mb-6" :color="AISEA_COLOR.GRAY" />
        <ul>
          <li v-for="filterItem in filterList" :key="filterItem.id">
            <filter-item
              :filterItem="filterItem"
              :isSmallIcon="isSmallIcon"
              :updateFilter="updateFilter"
            />
          </li>
        </ul>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
/**
 * フィルタ一覧で「船舶種別、プロット種別, 航路標識種別」ごとのカードごとに切り分けたコンポーネント
 * @parent O.FilterMap
 * @props filterType: String 「船舶種別、プロット種別、航路標識種別」に当たるフィルターの種別
 * @props filterTitle: String カードのタイトルで「船舶種別、プロット種別、航路標識種別」に当たるデータ
 * @props filterList: Array カード内に表示されるフィルター一覧のデータ
 * @porps isSmallIcon: Boolean 船舶種別だけアイコンサイズが異なるため、A.FilterItem内でアイコンサイズのCSSを分岐させるフラグ
 * @props updateFilterSettings: Function フィルターのvuex内のstoreとFireStoreを更新する関数,A.FilterItem内で発火させる。
 */
import { ColorMixin } from "@/mixins";
import FilterItem from "@/components/atoms/FilterItem";

export default {
  name: "M.FilterCard",
  mixins: [ColorMixin],
  components: {
    FilterItem,
  },
  props: {
    filterType: {
      type: String,
      required: true,
    },
    filterTitle: {
      type: String,
      required: true,
    },
    /** すべてのリスト */
    filterList: {
      type: Array,
      required: true,
    },
    isSmallIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    updateFilterSettings: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    this.isAllSwitch = this.filterList.every((filter) => filter.switchStatus);
  },
  watch: {
    filterList(list) {
      this.isAllSwitch = list.every((filter) => filter.switchStatus);
    },
  },
  data() {
    return {
      isAllSwitch: false,
    };
  },
  methods: {
    /** 全チェックの切替 */
    async handleClickAll() {
      this.isAllSwitch = !this.isAllSwitch;
      await this.updateFilterSettings({
        type: this.filterType,
        id: null,
        status: this.isAllSwitch,
        isAll: true,
      });
    },
    /** チェック状態の切替（子コンポーネントから発火される） */
    async updateFilter(param) {
      await this.updateFilterSettings({
        type: this.filterType,
        id: param.id,
        status: param.status,
        isAll: param.isAll,
      });
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/aisea/mixin";

.grid-map-filter-card-container {
  .filter-card {
    background: $aisea-blue-gray;
  }

  span.icon-header {
    .vs-icon {
      @include image-button("sm");
      background-color: $aisea-dark-blue;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: #595d69;
      }

      &:active {
        background-color: #8b8e97;
      }
    }
  }
}
</style>
